import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
        about: 'About',
        videos: 'Videos',
        interviews: 'Interviews',
        music: 'Music',
        photos: 'Photos',
        contact: 'Contact',
        newsArticles: 'Articles',
        snippet:'Upcoming',
        subscribe:'Subscribe',
        download:'Download',
        welcomeMsg: 'Chad Ashe is a Canadian singer, rapper and producer with love filled lyrics, laid back' +
            ' vocals and a chill soundscape.',
        controversy: 'In 2021, his controversial single “Wahala” gained nation wide attention.',
        readMore: 'Read more...',
        clickView: 'Click to View',
        interviewWith: 'with ',
        hustleDescription: 'Chad discusses current events in pop culture, discusses the dark side of education, and drops jewels on hustling.',
        warmUpDescription: 'Chad stops by Montreal’s #1 urban radio station to discuss his history as a musician, the future of education, and performs his first single “First thing is First”.',
        viewNow: 'View now',
        streamTitle: 'Stream now on the following platforms',
        pressTitle: 'Press photos',
        contactDescription: 'Chad Ashe is an independent, self-managed artist.',
        contactSignature: 'Contact Chad',
        moreAboutChad: 'More about Chad',
        aboutDescription1: 'Chad Ashe is a Canadian singer, rapper and producer with love filled lyrics,' +
            'laid back vocals and a chill soundscape. Raised in Montreal, Quebec, he is ' +
            'also a teacher and son of French Canadian singing sensation Sylvie Desgroseilliers.',
        aboutDescription2:'He has been a prolific artist in his city, as both a rapper and a DJ. Chad Ashe' +
            'has done shows in clubs and theaters, as well as a multitude of DJ residencies ' +
            'all across Montreal. In 2020, Ashe released seven self-produced singles to begin ' +
            'his campaign.',
        aboutDescription3: 'In 2021, his controversial single “Wahala” gained nation wide attention when he ' +
            ' was unrightfully suspended from his teaching duties because of the song‘s music ' +
            ' video. He is currently an independent artist who is on a quest to redefine the ' +
            ' image of the teacher. Chad Ashe releases his debut album “Afrokeb” on November 25th 2022.'
    },
    'fr': {
        about: 'À propos',
        videos: 'Vidéos',
        interviews: 'Entrevues',
        music: 'Musique',
        photos: 'Photos',
        contact: 'Contact',
        newsArticles: 'Articles',
        snippet: 'A venir',
        subscribe: 'S\'abonner',
        download: 'Télécharger',
        welcomeMsg: 'Chad Ashe est un chanteur, rappeur et producteur canadien avec des paroles pleines d\'amour, des voix décontractées et un paysage sonore relaxant.',
        controversy: 'En 2021, sa chansons controversé "Wahala" a attiré l\'attention du pays.',
        readMore: 'Lire la suite...',
        clickView: 'Cliquez pour visionner',
        interviewWith: 'avec ',
        hustleDescription: 'Chad discute d’actualité de la culture pop, discute le côté obscur de l\'éducation et donne ca philosophy sur le “hustle”.',
        warmUpDescription: 'Chad passe par la station de radio urbaine n ° 1 de Montréal pour discuter de son histoire en tant que musicien, de l\'avenir de l\'éducation, et interprète son premier single « First thing is First ».',
        viewNow: 'Voir',
        streamTitle: 'Diffusez maintenant sur les plateformes suivantes',
        pressTitle: 'Photos de presse',
        contactDescription: 'Chad Ashe est un artiste indépendant et autogéré.',
        contactSignature: 'Contactez Chad',
        moreAboutChad: 'En savoir plus sur Chad',
        aboutDescription1: 'Chad Ashe est un chanteur, rappeur et producteur canadien avec des paroles pleines d\'amour, ' +
            'des voix décontractées et un paysage sonore relaxant. Élevé à Montréal, au Québec, il est ' +
            'professeur et fils de la chanteuse canadienne-française Sylvie Desgroseilliers.',
        aboutDescription2:'Il est un artiste prolifique dans sa ville, à la fois en tant que rappeur et DJ. Chad Ashe ' +
            'a fait des spectacles dans des clubs et des théâtres, ainsi qu\'une multitude de résidences de DJ partout à ' +
            'Montréal. En 2020, Ashe a sorti sept titre musicaux autoproduits pour commencer sa campagne.',
        aboutDescription3: 'En 2021, sa chansons controversé "Wahala" a attiré l\'attention du pays lorsqu\'il a été ' +
            'injustement suspendu de ses fonctions d\'enseignant à cause du video clip de la chanson.' +
            'Il est actuellement un artiste indépendant qui cherche à redéfinir l\'image de l\'enseignant. ' +
            'Chad Ashe sort son premier album "Afrokeb" le 25 novembre 2022.'
    }
};

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'fr', // set fallback locale
    messages, // set locale messages
});

export default i18n;